import LinkToClaimsPage from './LinkToClaimsPage';

export default LinkToClaimsPage;
